









































































































































































































































import { Vue, Component, Prop } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { useThemeStore } from "@/shared/store/theme";
import { AuthorizedSigner } from "@/shared/types";
import UsStateSelector from "@/shared/components/UsStateSelector.vue";
import { useAuthorizedSignerStore } from "@/employee/store/authorizedSigner";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import _ from "lodash";
import * as Ssn from "@/shared/ssn";

@Component({
  components: {
    Button,
    UsStateSelector,
    GenericLoadingSpinner
  }
})
export default class EditAuthorizedSigner extends Vue {
  themeStore = useThemeStore();
  authorizedSignerStore = useAuthorizedSignerStore();

  isSubmitting = false;

  @Prop({ required: true })
  authorizedSigner: AuthorizedSigner;

  @Prop({ required: true })
  onSave: () => Promise<void>;

  @Prop()
  toggleClose: () => void;

  @Prop()
  isNew: boolean;

  @Prop()
  show: { value: boolean };

  @Prop({ required: false, default: false })
  isLoading: boolean;

  @Prop({ required: false, default: false })
  disableSubmit: boolean;

  @Prop({ required: false })
  readonlyProps: [];

  get title () {
    return this.isNew ? "Add Authorized Signer" : "Update Authorized Signer";
  }

  get submitDisabled () {
    return !this.isValid || this.isSubmitting || this.isLoading || this.disableSubmit;
  }

  get isValid () {
    return !this.$validator.errors.any();
  }

  get isEligibleForDebitCard () {
    return this.authorizedSignerStore.isEligibleForDebitCard;
  }

  save () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      this.isSubmitting = true;
      this.onSave().finally(() => {
        this.isSubmitting = false;
      });
    });
  }

  isDisabled (field): boolean {
    if (!this.readonlyProps || this.readonlyProps.length < 1) {
      return false;
    }

    return this.readonlyProps.findIndex(x => x === field) >= 0;
  }

  ssnMasked (): string {
    if (!this.authorizedSigner.ssn) {
      return "";
    }
    return Ssn.lastFour(this.authorizedSigner.ssn);
  }

  onSsnChange (e) {
    this.$emit("ssnChanged", e);
  }
}
